import React, { useEffect, useState } from "react"
import { fetchProjects } from "src/features/projects/api/projectsApi"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "src/components/ui/select"

export default function ProjectFilter({ value, onChange }) {
  const [projects, setProjects] = useState([])

  useEffect(() => {
    fetchProjects({ per_page: 100 })
      .then((d) => setProjects(d.projects || []))
      .catch(() => {})
  }, [])

  const selectValue = value ? String(value) : "all"

  return (
    <Select
      value={selectValue}
      onValueChange={(val) => onChange(val === "all" ? "" : val)}
    >
      <SelectTrigger className="w-[180px] h-9 text-[13px] text-slate-700">
        <SelectValue placeholder="All projects" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">All projects</SelectItem>
        {projects.map((p) => (
          <SelectItem key={p.id} value={String(p.id)}>
            {p.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
